import React, { useState } from 'react';
import { ArrowButtonHome } from '../sideBySide/LivePreview';
import { BannerSplitData } from '../../BannerSplitPage';
import { DesktopIcon } from '../../../../assets/DesktopIcon';
import { MobileIcon } from '../../../../assets/MobileIcon';

interface BannerLivePreviewProps {
    bannerData: BannerSplitData;
}

const BannerLivePreview: React.FC<BannerLivePreviewProps> = ({ bannerData }) => {
    const [viewMode, setViewMode] = useState<'desktop' | 'mobile'>('desktop');
    const isMobileView = viewMode === 'mobile';

    const bgDesktop = bannerData.desktopSrc ? `url(${bannerData.desktopSrc})` : 'none';
    const bgMobile = bannerData.mobileSrc ? `url(${bannerData.mobileSrc})` : bgDesktop;

    const showButton = Boolean(bannerData.url && bannerData.buttonText);

    return (
        <div className="banner-preview-container live-preview-section mt-4">
            <div className="preview-header">
                <h3> LIVE PREVIEW </h3>
                <div className="view-mode-toggle">
                    <button
                        type="button"
                        onClick={() => setViewMode('desktop')}
                        className={viewMode === 'desktop' ? 'active' : ''}
                    >
                        <DesktopIcon width={16} height={16} fill={viewMode === 'desktop' ? '#5493DA' : '#64748b'} /> Desktop
                    </button>
                    <button
                        type="button"
                        onClick={() => setViewMode('mobile')}
                        className={viewMode === 'mobile' ? 'active' : ''}
                    >
                        <MobileIcon width={16} height={16} fill={viewMode === 'mobile' ? '#5493DA' : '#64748b'} /> Mobile
                    </button>
                </div>
            </div>
            
            <div className={`splitBannerHome__container ${isMobileView ? 'is-mobile' : ''}`}>
                <div className="splitBannerHome__leftPanel" style={{ backgroundColor: bannerData.backgroundColor }}>
                    {bannerData.eyebrow && (
                        <p className="splitBannerHome__eyebrow" style={{ color: bannerData.eyebrowColor }}>
                            {bannerData.eyebrow}
                        </p>
                    )}
                    
                    {bannerData.title && (
                        <h2 className="splitBannerHome__title" style={{ color: bannerData.titleColor }}>
                            {bannerData.title}
                        </h2>
                    )}
                    
                    {bannerData.subtitle && (
                        <p className="splitBannerHome__subtitle" style={{ color: bannerData.subtitleColor }}>
                            {bannerData.subtitle}
                        </p>
                    )}
                    
                    {showButton && (
                        <div className="splitBannerHome__btnWrapper">
                            <a 
                                className="splitBannerHome__btn" 
                                href={bannerData.url || '#'} 
                                target={bannerData.openInNewTab ? "_blank" : "_self"} 
                                rel="noopener noreferrer"
                                onClick={(e) => e.preventDefault()}
                            >
                                <button style={{ color: bannerData.buttonColor, borderColor: bannerData.buttonColor }}>
                                    {bannerData.buttonText}
                                    {bannerData.showArrow && <ArrowButtonHome />}
                                </button>
                            </a>
                        </div>
                    )}
                </div>

                <div 
                    className="splitBannerHome__rightPanel"
                    style={{
                        '--bg-desktop': bgDesktop,
                        '--bg-mobile': bgMobile,
                    } as React.CSSProperties}
                />
            </div>
        </div>
    );
};

export default BannerLivePreview;